import React, { useState } from 'react';
import html2canvas from 'html2canvas';
import * as analytics from '../../lib/analytics';

interface RecapShareButtonProps {
  dateLabel: string;
  matchId: string;
}

export default function RecapShareButton({ dateLabel, matchId }: RecapShareButtonProps) {
  const [toast, setToast] = useState<string | null>(null);
  const [capturing, setCapturing] = useState(false);

  const handleShareImage = async () => {
    if (capturing) return;
    const node = document.getElementById('recap-card');
    if (!node) return;
    setCapturing(true);
    analytics.track('recap_share_tap', { matchId, method: 'image' });
    try {
      const canvas = await html2canvas(node, { backgroundColor: '#0F1316', scale: 2, useCORS: true });
      const blob: Blob | null = await new Promise((resolve) => canvas.toBlob(resolve, 'image/png'));
      if (!blob) throw new Error('no blob');
      const file = new File([blob], `recap-${matchId}.png`, { type: 'image/png' });

      const nav = navigator as any;
      if (typeof nav.canShare === 'function' && nav.canShare({ files: [file] })) {
        await nav.share({ files: [file], title: 'Recap del partido', text: `Recap del partido del ${dateLabel} ⚽` });
      } else {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `recap-${matchId}.png`;
        a.click();
        URL.revokeObjectURL(url);
        setToast('Imagen descargada');
        setTimeout(() => setToast(null), 2000);
      }
    } catch {
      setToast('No se pudo generar la imagen');
      setTimeout(() => setToast(null), 2000);
    } finally {
      setCapturing(false);
    }
  };

  const handleShare = async () => {
    const url = window.location.href;
    const text = `Mirá el recap del partido del ${dateLabel} 👀`;

    const method = typeof (navigator as any).share === 'function' ? 'web-share' : 'clipboard';
    analytics.track('recap_share_tap', { matchId, method });

    if (typeof (navigator as any).share === 'function') {
      try {
        await (navigator as any).share({ title: 'Recap del partido', text, url });
      } catch {
        // user cancelled — silencioso
      }
      return;
    }

    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(url);
      setToast('Link copiado');
      setTimeout(() => setToast(null), 2000);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, marginTop: 16 }}>
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', justifyContent: 'center' }}>
        <button
          onClick={handleShare}
          style={{
            background: '#00C853',
            color: '#000',
            border: 'none',
            padding: '14px 28px',
            borderRadius: 10,
            fontSize: 15,
            fontWeight: 700,
            cursor: 'pointer',
            minWidth: 150,
          }}
        >
          Compartir link
        </button>
        <button
          onClick={handleShareImage}
          disabled={capturing}
          style={{
            background: 'transparent',
            color: '#00C853',
            border: '1px solid #00C853',
            padding: '14px 28px',
            borderRadius: 10,
            fontSize: 15,
            fontWeight: 700,
            cursor: capturing ? 'not-allowed' : 'pointer',
            minWidth: 150,
          }}
        >
          {capturing ? 'Generando…' : '📸 Imagen'}
        </button>
      </div>
      {toast && (
        <span style={{ fontSize: 13, color: '#4CAF50' }} role="status">
          {toast}
        </span>
      )}
    </div>
  );
}
